










import {Vue, Component, Prop} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
@Component({
    components: {
    },
})
export default class HeroImage2 extends Mixins(ScreenSizeMixin) {
    @Prop({default: ''})
    public line1!: string;
    @Prop({default: ''})
    public line2!: string;
    @Prop({default: ''})
    public image!: string;
    @Prop({default: false})
    public alignTop!: boolean;
    @Prop({default: 1})
    public height!: number;
    public heroStyle = '';
    private autocomplete!: any;
    public calculateHeroStyle() {
        let requestedHeight: number = this.windowHeight() * this.height;
        if (this.isXS(null)) {
            requestedHeight *= 0.40;
        }
        const height = `height:${requestedHeight}px;`;
        return `${height}`;
    }
    public mounted() {
        this.heroStyle = this.calculateHeroStyle();
    }
    public created() {
        this.heroStyle = this.calculateHeroStyle();
        this.onResize(() => {
            this.heroStyle = this.calculateHeroStyle();
        });
    }
}
